import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-redirection-handler',
  template: '',
})
export class RedirectionHandlerComponent implements OnInit {
  constructor(@Inject(Window) private window: Window) {
  }

  ngOnInit(): void {
    const currentUrl = this.window.location.href;
    const url = new URL(currentUrl);
    const params = new URLSearchParams(url.search);
    const paramData: any = {};
    params.forEach((value: string, key: string): void => {
      paramData[key] = value;
    });

    if (this.window.opener && this.window.opener.postMessage) {
      this.window.opener.postMessage({ from: 'RedirectionHandler', data: paramData }, this.window.location.origin);
    }

    this.window.close();
  }
}
